import React from "react";
import RubberBand from "react-reveal/RubberBand";
import Fade from "react-reveal/Fade";

const header = {
  textTransform: "uppercase",
  fontSize: "50px",
  color: "#6cf16b",
  textAlign: "center",
  paddingTop: "50px",
};

const parallex = {
  position: "absolute",
  top: "0",
  left: "0",
  right: "0",
  bottom: "0",
  zIndex: "-1",
};

const bannerimg = {
  height: "400px",
  width: "100%",
  opacity: "0.5",
};

const BannerImage = ({ title, image }) => {
  return (
    <div style={{ height: "370px", marginTop: '44px' }}>
      <RubberBand>
        <h1 style={header}>{title}</h1>
      </RubberBand>
      <div style={parallex}>
        <Fade clear>
          <img src={image} alt="banner" style={bannerimg} />
        </Fade>
      </div>
    </div>
  );
};

export default BannerImage;
